import { gsap, ScrollTrigger } from 'gsap/all';
import SplitText from "../__vendor/SplitText.min.js";

gsap.registerPlugin(ScrollTrigger);

const sectionProcess = () => {
    const processes = document.querySelectorAll('.processes > div'); 

    processes.forEach(process => {
        const processContent = process.querySelector('.process-content');
        const text = new SplitText(process.querySelector(".process p"), { type: "chars" });

        gsap.set(text.chars, {
            autoAlpha: 0,
            y: 15
        });

        const sectionProcessTl = gsap.timeline({
            paused: true
        });

        sectionProcessTl
            .set(process, {
                className: "+= active" 
            }, 0.15)
            .set(processContent, {
                className: '+= process process-content active'
            }, 0.15)
            .to(text.chars, {
                autoAlpha: 1,
                y: 0,
                stagger: 0.025,
            }, 0.5);

        ScrollTrigger.create({
            scroller:'[data-scroll-container]',
            trigger: processContent,
            start: 'top bottom-=200',
            end: 'bottom top',
            animation: sectionProcessTl,
            toggleActions: 'play none none none',
        });
    });

    const text = new SplitText('.about-processes-section h3', { type: "chars" });

    gsap.set(text.chars, {
        autoAlpha: 0,
        y: 15
    });

    const titleTL = gsap.timeline({
        paused: true
    });

    titleTL
        .to(text.chars, {
            autoAlpha: 1,
            y: 0,
            stagger: 0.015,
        }, 0.1);

    ScrollTrigger.create({
        scroller:'[data-scroll-container]',
        trigger: '.about-processes-section h3',
        start: 'top bottom-=200',
        end: 'bottom top',
        animation: titleTL,
        toggleActions: 'play none none none',
    });
};

export default sectionProcess;
